<template>
    <div class="app-body-container" style="padding-bottom: 30px">

        <el-row class="mg-t-10">
            <el-col :span="24">
                <el-card shadow="hover" class="mycard-a">

                    <!--title-->
                    <div class="mycard-title">选择订单流程方案</div>

                    <!--button-->
                    <div style="padding-top: 25px">
                        <el-button type="primary" style="width: 100px" @click="saveFlow">保存</el-button>
                    </div>

                    <!--方案列表-->
                    <div v-loading="flow_loading">
                        <div v-for="flow in flow_list">
                            <div class="wf-chose">
                                <el-checkbox :label="flow.name"
                                             v-model="flow.is_checked"
                                             @change="flow_change(flow.id)"></el-checkbox>
                            </div>
                            <div class="wf-steps">
                                <el-steps>
                                  <el-step v-for="(step,step_idx) in flow.list" :key="step_idx" :class="step.is_unchecked?'off':''">
                                      <div slot="icon" style="cursor: pointer" @click="step_click(flow.id,step.code)">&nbsp;</div>
                                      <div slot="title" style="cursor: pointer" @click="step_click(flow.id,step.code)">{{step.value}}</div>
                                  </el-step>
                                </el-steps>
                            </div>
                        </div>
                        <div style="height: 300px">&nbsp;</div>
                    </div>

                </el-card>
            </el-col>
        </el-row>

    </div>
</template>

<script>
export default {
    data: function () {
        return {
            flow_list: [],       // 流程列表
            flow_loading:false
        }
    },
    methods: {
        loadFlow: function () {
            let self = this
            self.flow_loading = true
            self.xFetch.post(self.xApi('/robot/order/flowplan/getPlan'), {}).then(function (res) {
                self.flow_loading = false

                if (res.data.code != '00') {
                    self.xEui.msg_error(res.data.text)
                    return
                }

                let flow_list = res.data.data.flowList;
                let sel_flow_id = res.data.data.type;                // 选中的流程
                let sel_steps = (res.data.data.flow || '').split(','); // 选中的步骤

                flow_list.forEach(function (flow) {
                    flow.is_checked = flow.id == sel_flow_id ? true : false;
                    flow.list.forEach(function (step) {
                        if (flow.id == sel_flow_id) {
                            step.is_unchecked = sel_steps.indexOf(step.code) == -1 ? true : false;
                        }
                        else {
                            step.is_unchecked = true;
                        }
                    })
                })

                self.flow_list = flow_list;
            });
        },
        set_flow_val: function (fid, bol) {
            let self = this
            self.flow_list.forEach(function (flow, idx) {
                if (flow.id == fid) {
                    flow.is_checked = bol;
                }
                else {
                    flow.is_checked = false;
                }
                self.$set(self.flow_list, idx, flow)
            })
        },
        flow_change: function (fid) {
            let self = this
            self.flow_list.forEach(function (flow, idx) {
                if (flow.id == fid) {
                    self.set_flow_val(fid, flow.is_checked || false)
                }
            })
        },
        step_click: function (fid, stepCode) {
            let self = this
            self.flow_list.forEach(function (flow, flow_idx) {
                if (flow.id == fid) {
                    flow.list.forEach(function (step) {
                        if (step.code == stepCode) {
                            if (step.must_check/*表示该步骤必选*/) {

                            }
                            else {
                                step.is_unchecked = !(step.is_unchecked || false)
                            }
                        }
                    })
                    self.$set(self.flow_list, flow_idx, flow);
                }
            })
        },
        saveFlow: function () {
            let self = this

            // 选中的流程
            let flow_id = null,
                    flow = null,
                    flow_steps = []

            self.flow_list.forEach(function (item) {
                if (item.is_checked) {
                    flow_id = item.id
                    flow = item
                    item.list.forEach(function (s_item) {
                        if (!s_item.is_unchecked) {
                            flow_steps.push(s_item.code)
                        }
                    })
                }
            })

            if (!flow) {
                self.xEui.msg_error('请选择订单流程方案')
                return
            }

            if(!flow_steps.length){
                self.xEui.msg_error('方案必须至少包含一个步骤')
                return
            }

            // save
            self.xEui.myloading('保存中...')
            self.xFetch.post(self.xApi('/robot/order/flowplan/updatePlan'), {
                type: flow_id,
                flow: flow_steps.join(',')
            },{xPostType:'form'}).then(function (res) {
                self.xEui.loading_close()

                if (res.data.code != '00') {
                    self.xEui.msg_error(res.data.text)
                }
                else {
                    self.xEui.msg_success('订单流程方案保存成功')
                    self.loadFlow();
                }
            });
        }
    },
    created: function () {
        this.loadFlow();
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .mycard-title{ color: #333 }
</style>
<style>
    /*方案选择*/
    .wf-chose{ padding: 50px 0px 20px 0px }
    .wf-chose .el-checkbox__input.is-checked+.el-checkbox__label{ color: #606266 }
    .wf-steps{ padding: 0px 50px  }
    .wf-steps .el-step__title{ color: #606266 !important;font-weight: normal !important;font-size: 14px;}
    .wf-steps .el-step__icon{ width: 14px;height: 14px;border-color:#91D5FF;overflow: hidden;position: relative;top: 5px }
    .wf-steps .el-step__line{background-color:rgba(0,0,0,0.04)}
    .wf-steps .el-step.off .el-step__icon{ border-color:#bbb  }
</style>


// WEBPACK FOOTER //
// src/views/order/workflow.vue